export const MEMBER_SAVE_MEMBER_BEGIN = 'MEMBER_SAVE_MEMBER_BEGIN';
export const MEMBER_SAVE_MEMBER_SUCCESS = 'MEMBER_SAVE_MEMBER_SUCCESS';
export const MEMBER_SAVE_MEMBER_FAILURE = 'MEMBER_SAVE_MEMBER_FAILURE';
export const MEMBER_SAVE_MEMBER_DISMISS_ERROR = 'MEMBER_SAVE_MEMBER_DISMISS_ERROR';
export const MEMBER_DELETE_MEMBER_BEGIN = 'MEMBER_DELETE_MEMBER_BEGIN';
export const MEMBER_DELETE_MEMBER_SUCCESS = 'MEMBER_DELETE_MEMBER_SUCCESS';
export const MEMBER_DELETE_MEMBER_FAILURE = 'MEMBER_DELETE_MEMBER_FAILURE';
export const MEMBER_DELETE_MEMBER_DISMISS_ERROR = 'MEMBER_DELETE_MEMBER_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/member/redux/constants.js